export { default } from "./useGuidedHighlightingStudentAnswer";
